import React from "react" 
import { useDetailScreenCtx } from "../DetailScreensRender"


export default function TrxDetailLabel({ label, value, size="md", className="" }:{ label:string; value:any; size?:string; className?:string }){
  const { visualEffects }:any = useDetailScreenCtx()
  return (
    <span 
      style={{
        width: "50%",
        fontSize: size === "lg" ? "1rem" : "0.875rem",
        fontWeight: "500",
        color: "#000000",
        lineHeight: "1.2rem",
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </span>
  )
}